import * as React from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

type SearchInputProps = Omit<React.ComponentProps<"input">, "type"> & {
  containerClassName?: string;
  iconClassName?: string;
};

/**
 * Search box that browser autofill leaves alone. Chrome ignores
 * autocomplete="off" and treats every input outside a <form> as one form, so
 * autofilling a dialog (e.g. Invite Member) also wrote the email into the
 * page's search box. Its own role="search" form plus type="search" keeps it
 * out of other fields' autofill.
 */
export function SearchInput({
  containerClassName,
  iconClassName,
  className,
  ...props
}: SearchInputProps) {
  return (
    <form
      role="search"
      className={cn("relative", containerClassName)}
      onSubmit={(e) => e.preventDefault()}
    >
      <Search
        aria-hidden="true"
        className={cn(
          "pointer-events-none absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2 text-gray-400",
          iconClassName,
        )}
      />
      <Input
        type="search"
        autoComplete="off"
        className={cn("h-10 pl-9 [&::-webkit-search-cancel-button]:hidden", className)}
        {...props}
      />
    </form>
  );
}
